<template>
  <div class="research-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="content-line">
        <div class="left">
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research1.png"
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <div class="blue-title">科技知识图谱构建及可视化</div>
            <div class="content">
              <span class="dark-red">[研究内容] </span
              >针对中英文科技大数据构建大规模科技知识图谱：<br />
              (1) 实现科技领域实体、属性、关系等图谱要素的自动抽取;<br />
              (2)
              设计科技知识图谱的底层知识Schema，建立领域本体(包括概念、概念层次、属性/关系及其定义域与值域概念集等);
              <br />(3) 构建各类人才库、机构库、术语库、学术网络以及相关专题库;
              <br />(4)实现知识计算、融合及可视化，形成人才画像、热点挖掘、趋势分析、资源分布等可视化应用。
              <br /><span class="dark-red">[支撑项目] </span><br />(1)
              浙江省重点研发计划项目：“<span class="green-tag"
                >促进成果转化的科技大数据服务平台开发及应用</span
              >”; <br />(2) 浙江省数字化改革重点扶持项目(之江实验室):“<span
                class="green-tag"
                >未来实验室数字化管理和科研辅助工具平台</span
              >”。 <br /><span class="dark-red">[研究成果]</span>
              发表JOCS、CCPE、KBS、TST等国际期刊论文
            </div>
          </div>
        </div>
      </div>
      <div class="split-line"></div>

      <div class="content-line">
        <div class="left">
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research2.1.png"
            alt=""
          />
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research2.2.png"
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <div class="blue-title">知识表示学习方法研究</div>
            <div class="content">
              <span class="dark-red">[研究内容]</span>
              研究科技领域文档的表示学习方法：<br />(1)
              利用海量科技文献数据+领域特征知识，研究针对科技领域的预训练神经网络语言模型，为科技领域各种知识表示学习提供语义基础。
              <br />(2)
              在预训练语言模型的基础上，结合下游任务进行相应的fine-tune研究，实现科技文献字词、句子、段落和文章等不同级别的文本知识表示即向量化。
              <br /><span class="dark-red">[支撑项目] </span><br />(1)
              浙江省重点研发计划项目：“<span class="green-tag"
                >促进成果转化的科技大数据服务平台开发及应用</span
              >”; <br />(2) 浙江省数字化改革重点扶持项目(之江实验室):“<span
                class="green-tag"
                >未来实验室数字化管理和科研辅助工具平台</span
              >”。 <br /><span class="dark-red">[研究成果] </span
              >发表ICDE、TST、CCPE等国际会议/期刊论文
            </div>
          </div>
        </div>
      </div>
      <div class="split-line"></div>

      <div class="content-line">
        <div class="left">
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research3.png"
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <div class="blue-title">混合向量检索核心算法研究</div>
            <div class="content">
              <span class="dark-red">[研究内容]</span>
              针对现实应用（如商品搜索、电影推荐等）中同时考虑结构化与非结构化约束的查询场景，提出了一种新型的原生混合向量查询方法：
              <br />(1)
              实现基于近邻图的高效混合查询算法，打破现有分离式混合查询方案的瓶颈；
              <br />(2)
              设计近邻图层次化索引，实现分布式高效检索。打造基于混合向量检索的语义搜索引擎，为智能化应用提供核心技术支撑。
              <span class="dark-red">[支撑项目] </span><br />(1)
              浙江省重点研发计划项目：“<span class="green-tag"
                >促进成果转化的科技大数据服务平台开发及应用</span
              >”; <br />(2) 浙江省数字化改革重点扶持项目(之江实验室):“<span
                class="green-tag"
                >未来实验室数字化管理和科研辅助工具平台</span
              >”； <br />(3) 浙江省重点研发计划项目：“<span class="green-tag"
                >重大活动公共安全智能防控平台开发及应用示范</span
              >”。
              <span class="dark-red">[研究成果] </span
              >发表VLDB、KBS、CCPE等国际会议/期刊论文
            </div>
          </div>
        </div>
      </div>
      <div class="split-line"></div>

      <div class="content-line">
        <div class="left">
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research4.png"
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <div class="blue-title">复杂异构网络社区查询算法研究</div>
            <div class="content">
              <span class="dark-red">[研究内容]</span>
              针对复杂异构网络的社区查询问题，研究： <br />(1)
              基于节点属性相似度的k-core社区查询算法，首次针对异构属性图的社区查询提出解决方案；
              <br />(2)
              基于随机游走的k-truss社区核心骨干网络近似查询算法，首次针对复杂网络的社区骨干网络发现问题提出解决方案。研究成果可广泛应用于公公共安全防控、智能辅警、学术社团的挖掘与推荐、电子商务推荐等领域，具有较高的应用价值。
              <br /><span class="dark-red">[支撑项目]</span><br />(1)
              浙江省数字化改革重点扶持项目(之江实验室):“<span class="green-tag"
                >未来实验室数字化管理和科研辅助工具平台</span
              >”; <br />(2) 浙江省重点研发计划项目：“<span class="green-tag"
                >重大活动公共安全智能防控平台开发及应用示范</span
              >”; <br />(3) 浙江省属高校基础科研业务费项目重点培育专项：“<span
                class="green-tag"
                >复杂异构网络社区查询关键技术研究</span
              >”。 <br /><span class="dark-red">[研究成果]</span>
              投稿SIGMOD、VLDB等国际会议论文(审稿中)
            </div>
          </div>
        </div>
      </div>
      <div class="split-line"></div>

      <div class="content-line">
        <div class="left">
          <img
            class="left-img"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/research5.png"
            alt=""
          />
        </div>
        <div class="right">
          <div>
            <div class="blue-title">知识图谱查询算法研究</div>
            <div class="content">
              <span class="dark-red">[研究内容]</span>
              针对知识图谱的事实型与聚集型查询场景，分别研究： <br />(1)
              基于路径语义相似度的图查询算法，设计并实现语义相似度剪枝算法，在保证查询精度的基础上大幅提升查询效率；
              <br />(2)
              基于语义相似度随机游走的知识图谱聚集查询算法，支持常见的聚集函数、范围查询、分组查询等功能。研究成果可广泛应用于知识图谱的查询应用场景。
              <br /><span class="dark-red">[支撑项目]</span> <br />(1)
              国家自然科学基金面上项目：“<span class="green-tag"
                >语义驱动的知识图谱近似图查询关键技术研究</span
              >”； <br />(2) 国家自然科学基金青年项目:“<span class="green-tag"
                >面向大数据近似查询应用的在线聚集融合机制与优化研究</span
              >”; <br />(3) 浙江省科技计划公益项目:“<span class="green-tag"
                >RDF知识图谱分布式语义近似查询关键技术研究</span
              >”。 <br /><span class="dark-red">[研究成果]</span>
              发表ICDE、KBS等多篇国际会议/期刊论文，投稿TKDE期刊论文 (审稿中)
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.research-container {
  min-height: 100vh;
}
.item-container {
  width: 80%;
  margin: 0 auto;
}
.item-background {
  height: 60px;
}
.content-line {
  display: flex;
  margin-top: 40px;
}
.left {
  width: 45%;
  padding: 20px;
}
.right {
  width: 55%;
  padding: 20px;
  display: flex;
  align-content: center;
}
.left-img {
  width: 100%;
}
.split-line {
  height: 1px;
  width: 75%;
  border-block: 1px solid #a49d9d;
  margin: 20px auto;
}
.blue-title {
  font-size: 20px;
  color: #4f81bd;
  font-weight: bold;
  margin-bottom: 12px;
}
.dark-red {
  color: #c00000;
}
.green-tag {
  color: #00b050;
}
.content {
  font-size: 16px;
  line-height: 34px;
  font-weight: bold;
}
@media screen and (max-width: 900px) {
  .content-line {
    display: block;
  }
  .item-container {
    width: 100%;
  }
  .left {
    width: 100%;
  }
  .right {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/research/index.vue